"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TermFilter {
    constructor(config) {
        this.config = config;
    }
    getIdentifier() {
        return this.config.identifier;
    }
    getLabel() {
        return this.config.label;
    }
    getFilters(filters) {
        return {
            bool: {
                filter: filters.map((filter) => ({ term: { [this.config.field]: filter.value } }))
            }
        };
    }
    getSelectedFilter(filterSet) {
        return {
            type: 'ValueSelectedFilter',
            id: `${this.getIdentifier()}_${filterSet.value}`,
            identifier: this.getIdentifier(),
            label: this.config.label,
            value: filterSet.value,
            display: this.config.display || 'TermFilter'
        };
    }
}
exports.default = TermFilter;
